import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Pencil, Calendar, Sparkles } from "lucide-react";
import { format } from "date-fns";
import { es } from "date-fns/locale";

interface RoutineHeaderProps {
  hasRoutines?: boolean;
}

export const RoutineHeader = ({ hasRoutines = true }: RoutineHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <div className="flex items-center gap-3">
        {/* Animated icon */}
        <div className="relative">
          <div className="p-2.5 rounded-xl bg-primary/10 animate-pulse-glow">
            <Calendar className="h-5 w-5 text-primary" />
          </div>
          <Sparkles className="h-3 w-3 text-accent absolute -top-1 -right-1 animate-float" />
        </div>
        
        <div className="space-y-0.5">
          <h2 className="text-xl sm:text-2xl font-heading font-bold text-primary">
            Rutinas de Hoy
          </h2>
          <p className="text-sm text-muted-foreground capitalize">
            {format(new Date(), 'EEEE dd MMMM', { locale: es })}
          </p>
        </div>
      </div>
      
      {hasRoutines && (
        <Link to="/rutina">
          <Button 
            size="icon"
            className="rounded-full bg-primary hover:bg-primary/90 text-white transition-all hover:scale-110 hover:shadow-lg hover:shadow-primary/30"
            aria-label="Ver todas las rutinas"
          >
            <Pencil className="h-4 w-4" />
          </Button>
        </Link>
      )}
    </div>
  );
};
